import EleFormDynamic from './EleFormDynamic'

export default EleFormDynamic
